import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from "@angular/router";
import { ClrIconModule } from "@clr/angular";
import { DeliveryFormComponent } from "../delivery-form/delivery-form.component";
import { Delivery, DeliveryForm, StatusButtons } from "../../../_shared/interfaces";
import { AlertService, DeliveryStoreService, IAlertType, StaffStoreService } from "../../../_shared/services";
import { NgIf } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from "@cds/core/icon";

import { environment as env } from '../../../../environments/environment';

@Component({
  selector: 'app-delivery-update',
  standalone: true,
  imports: [
    RouterLink,
    ClrIconModule,
    DeliveryFormComponent,
    NgIf
  ],
  templateUrl: './delivery-update.component.html',
  styleUrl: './delivery-update.component.sass'
})
export class DeliveryUpdateComponent {
  projectId: string = '';
  jobId: number = 0;
  deliveryId: number = 0;
  loading: boolean = true;
  delivery: Delivery[] = [];
  statusLabel = 'label-light-blue';
  statusText = '';
  staffFirstName: string = '';
  staffLastName: string = '';
  staffEMail: string = '';
  devMode: boolean;

  statusButtons: StatusButtons[] = [
    { state: 'open',   display: 'Offen',   label: 'label-light-blue', icon: 'info-circle'},
    { state: 'closed', display: 'Gebucht', label: 'label-success',    icon: 'check-circle'},
    { state: 'noinvoice', display: 'Ohne Rechnung', label: 'label-warning', icon: 'exclamation-triangle'}
  ];

  constructor(
    private delss: DeliveryStoreService,
    private stss: StaffStoreService,
    private route: ActivatedRoute
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.projectId = params.get('projid') ?? '';
    this.jobId = parseInt(params.get('jobid') ?? '0', 10);
    this.deliveryId = parseInt(params.get('delid') ?? '0', 10);
    this.loadDelivery(this.projectId, this.jobId, this.deliveryId);
  }

  loadDelivery(prid:string, jobid:number, delid:number) {
    this.delss.getDelivery(prid, delid, jobid, 'all').subscribe({
      next: data1 => {

        this.delivery = data1.object;

        // Mitarbeiter personalisieren
        this.staffStatus(this.delivery[0].employee_phm);
      },
      complete: () => {
        // Status gestalten
        const statusline = this.findButtonStatus(this.delivery[0].status, this.statusButtons);
        this.statusLabel = this.statusButtons[statusline].label;
        this.statusText = this.statusButtons[statusline].display;

        this.loading = false;
      },
      error: () => {
        return;
      }
    });
  }

  staffStatus(staffID: number){
    console.log('StaffID ist ' + staffID);
    this.stss.getStaffById(staffID)
      .subscribe(staff => {
        if (!staff) {
          return;
        }
        this.staffFirstName = staff.object[0].firstname;
        this.staffLastName = staff.object[0].lastname;
        this.staffEMail = staff.object[0].email;
      })
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };
}
